@import "/src/styles/mixins.sass"

.filters
    position: relative
    z-index: 5
    display: flex
    align-items: flex-end
    gap: 2rem
    margin: 0 0.2rem 2em 0.2rem

    .select
        width: 100%

    .closeFiltersButton
        padding: 0.75rem 2rem

    @include mappy-bp(desktop)
        & > li
            width: 10rem

            &:first-child
                width: 20rem

            &:last-child
                width: auto

        .filler
            flex-grow: 1

        .closeFiltersButton
            margin-right: 3rem

    @include mappy-bp(tablet desktop)
        & > li
            flex: 1

            &:first-child
                flex: 2

        .select
            width: 100%

    @include mappy-bp(max tablet)
        flex-wrap: wrap
        gap: 1rem 2rem

        & > li
            flex: 1 0 calc(50% - 1rem)

            &:first-child
                flex: 1 0 100%

            &:last-child
                display: flex
                justify-content: flex-end

        .closeFiltersButton
            margin-top: 0.75rem

.listSkeleton
    @include label-large($disabled: true)
    margin-top: 1rem
    display: flex
    justify-content: center
    gap: 2rem

    @include mappy-bp(desktop)
        & > span
            //idk
            flex: 0 1 33.33%

    @include mappy-bp(mobile desktop)
        & > span
            flex: 0 1 50%

            &:first-of-type
                display: none

    @include mappy-bp(max mobile)
        text-align: center
        flex-direction: column

    & > span
        @include clickable-styled($outlined: true, $block: true, $disabled: true)
        @include text
        width: 100%
        padding: 1.7rem 1rem
        display: flex
        gap: 2rem

        span
            flex: 1

        span:first-of-type
            flex: 5

.list
    display: grid
    grid-template-columns: repeat(3, 1fr)
    gap: 2rem
    align-items: center

    @include mappy-bp(laptop)
        margin-top: 1rem

    @include mappy-bp(mobile desktop)
        grid-template-columns: repeat(2, 1fr)

    @include mappy-bp(max mobile)
        grid-template-columns: 1fr

    li
        @include clickable-styled($outlined: true, $block: true)
        @include text
        padding: 0.5rem

        .header
            width: 100%
            display: flex
            align-items: center

            & > svg
                margin: 0.5rem

            span
                padding: 0.5rem
                flex-grow: 1

            button
                padding: 0.5rem 1rem

        .details
            @include text--regular
            cursor: auto
            padding: 0 1rem 1rem
            width: 100%
            display: grid
            grid-template-columns: repeat(2, 1fr)

            span
                margin: 0.75rem 0 0

            span:nth-child(even)
                @include text
